import { create } from 'zustand'

export type ModalType = 'INGESTION_WARN_MODAL' | 'FILE_WARN_MODAL' | 'FILE_PREVIEW_MODAL' | 'ENCHANCED_MODAL' | 'PREVENT_PROMPTING_MODAL';

type PreventPromptingItem = {
  text: string;
  id: string;
  ttlSeconds?: number; // set if you want to timeout
}

type ModalStore = {
  currentModalType?: ModalType;
  fileWarningModalText?: string;
  filePreviewFileId?: string;
  preventPromptingThings?: PreventPromptingItem[];

  showIngestionWarningModal: () => void;
  showFilePreview: (filePreviewFileId: string) => void
  showFileWarningModal: (fileWarningModalText: string) => void;
  showPreventPromptingModal: () => boolean;
  closeModal: () => void;
  setPreventPromptingItem: (item: PreventPromptingItem) => void;
  clearPreventPromptingItem: (id: string) => void;
}

const getDefaultState = (): Partial<ModalStore> => ({
  currentModalType: undefined,
  fileWarningModalText: undefined,
  filePreviewFileId: undefined,
});

export const useModalStore = create<ModalStore>((set, get) => ({
  showPreventPromptingModal: () => {
    if (get().preventPromptingThings?.length) {
      set({ ...getDefaultState(), currentModalType: 'PREVENT_PROMPTING_MODAL' })
      return true;
    }
    return false;
  },
  showIngestionWarningModal: () => set({ ...getDefaultState(), currentModalType: 'INGESTION_WARN_MODAL' }),
  showFileWarningModal: (fileWarningModalText) => set({ ...getDefaultState(), fileWarningModalText, currentModalType: 'FILE_WARN_MODAL' }),
  showFilePreview: (filePreviewFileId) => set({ ...getDefaultState(), filePreviewFileId, currentModalType: 'FILE_PREVIEW_MODAL' }),
  setPreventPromptingItem: (item) => {
    const preventPromptingThings = (get().preventPromptingThings || []).filter(t => t.id !== item.id);
    preventPromptingThings.push(item);
    set({ preventPromptingThings });
    timeoutItem(item);
  },
  clearPreventPromptingItem: (id) => {
    const preventPromptingThings = (get().preventPromptingThings || []).filter(t => t.id !== id);
    set({ preventPromptingThings });
    if (preventPromptingThings.length === 0 && get().currentModalType === 'PREVENT_PROMPTING_MODAL') {
      get().closeModal();
    }
  },
  closeModal: () => {
    const newState = getDefaultState();
    if (get().currentModalType === 'PREVENT_PROMPTING_MODAL') {
      newState.preventPromptingThings = undefined;
    }
    set(newState);
  },
}));

const timeoutItem = (item: PreventPromptingItem) => {
  if (item && item.ttlSeconds) {
    setTimeout(() => {
      const thing = useModalStore.getState().preventPromptingThings?.find(t => t.id === item.id);
      if (thing === item) {
        // check identity in case new item with same id replaces old one
        useModalStore.getState().clearPreventPromptingItem(item.id);
      }
    }, 1000 * item.ttlSeconds);
  }
}
